<template>
  <div class="admin-auth-page">
    <div class="grid-layer"></div>
    <section class="console-card">
      <div class="console-copy">
        <p class="eyebrow">DERAS ADMIN CONSOLE</p>
        <h1>管理员控制台</h1>
        <p>这里是 DeRAS 审核、平台收入、机器人市场和高敏感运营数据入口。普通用户入口已经完全拆开。</p>
        <div class="security-list">
          <span>独立管理员入口</span>
          <span>后端 /admin 接口强鉴权</span>
          <span>生产环境建议独立域名部署</span>
        </div>
      </div>

      <el-form
        ref="adminForm"
        :model="adminForm"
        :rules="rules"
        label-position="top"
        class="admin-form"
      >
        <div class="form-head">
          <strong>DeRAS Console Login</strong>
          <button type="button" @click="$router.push({ name: 'home' })">返回用户首页</button>
        </div>

        <el-form-item label="管理员账号" prop="username">
          <el-input v-model.trim="adminForm.username" placeholder="请输入管理员账号"></el-input>
        </el-form-item>

        <el-form-item label="管理员密码" prop="password">
          <el-input v-model="adminForm.password" type="password" autocomplete="current-password" placeholder="请输入管理员密码"></el-input>
        </el-form-item>

        <button class="admin-login-btn" type="button" :disabled="submitting" @click="submitAdminLogin">
          {{ submitting ? '正在进入控制台...' : '进入管理员控制台' }}
        </button>
      </el-form>
    </section>
  </div>
</template>

<script>
import { loginAdmin } from '../api/auth'
import { getApiErrorMessage } from '../api/http'
import { setAdminAuthUser, setAdminToken } from '../utils/auth'

export default {
  name: 'AdminLogin',
  data() {
    return {
      submitting: false,
      adminForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入管理员密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitAdminLogin() {
      this.$refs.adminForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const response = await loginAdmin(this.adminForm)
          if (response.data.code !== 200) {
            this.$message.error(response.data.msg || '管理员登录失败')
            return
          }
          const data = response.data.data || {}
          setAdminToken(data.token || `admin-token-${Date.now()}`)
          setAdminAuthUser(data.user || { username: this.adminForm.username })
          this.$message.success('管理员登录成功')
          const redirect = this.$route.query.redirect
          const allowList = ['adminTaskMarket', 'robotMarket', 'adminRevenue', 'adminOrders', 'adminSdkDevices', 'adminUsers', 'adminOpenApiDoc', 'adminhome']
          this.$router.push({ name: redirect && allowList.includes(redirect) ? redirect : 'adminTaskMarket' })
        } catch (error) {
          this.$message.error(getApiErrorMessage(error, '管理员登录请求失败，请稍后重试。'))
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.admin-auth-page {
  position: relative;
  min-height: 100vh;
  display: grid;
  place-items: center;
  overflow: hidden;
  padding: 32px;
  color: #f4fbff;
  background:
    radial-gradient(circle at 18% 12%, rgba(142, 231, 255, 0.14), transparent 28%),
    radial-gradient(circle at 86% 20%, rgba(116, 242, 191, 0.12), transparent 26%),
    linear-gradient(135deg, #050910 0%, #071421 52%, #04070d 100%);
}

.grid-layer {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(143, 241, 199, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(143, 241, 199, 0.06) 1px, transparent 1px);
  background-size: 42px 42px;
  opacity: 0.68;
}

.console-card {
  position: relative;
  z-index: 1;
  width: min(1120px, 100%);
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(360px, 440px);
  gap: 24px;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid rgba(142, 231, 255, 0.16);
  background: rgba(5, 16, 28, 0.76);
  box-shadow: 0 34px 90px rgba(0, 0, 0, 0.46);
  backdrop-filter: blur(18px);
}

.console-copy {
  min-height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 36px;
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(142, 231, 255, 0.1), rgba(116, 242, 191, 0.06)),
    rgba(255, 255, 255, 0.04);
}

.eyebrow {
  margin: 0 0 16px;
  color: #8ee7ff;
  font-size: 12px;
  letter-spacing: 0.22em;
}

.console-copy h1 {
  margin: 0;
  font-size: clamp(38px, 5vw, 70px);
  line-height: 1;
}

.console-copy p {
  max-width: 620px;
  margin: 24px 0 0;
  color: rgba(244, 251, 255, 0.72);
  font-size: 16px;
  line-height: 1.9;
}

.security-list {
  display: grid;
  gap: 12px;
  margin-top: 34px;
}

.security-list span {
  padding: 13px 15px;
  border-radius: 14px;
  color: rgba(244, 251, 255, 0.84);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.admin-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
}

.form-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
}

.form-head strong {
  font-size: 20px;
}

.form-head button {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 9px 12px;
  color: #f4fbff;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
}

.admin-form :deep(.el-form-item__label) {
  color: rgba(244, 251, 255, 0.82);
}

.admin-form :deep(.el-input__inner) {
  color: #fff;
  border-radius: 8px;
  border-color: rgba(143, 241, 199, 0.16);
  background: rgba(2, 8, 17, 0.72);
}

.admin-login-btn {
  width: 100%;
  height: 48px;
  margin-top: 8px;
  border: none;
  border-radius: 8px;
  color: #03101d;
  font-weight: 800;
  cursor: pointer;
  background: linear-gradient(135deg, #8ee7ff, #74f2bf);
}

.admin-login-btn:disabled {
  cursor: not-allowed;
  opacity: 0.72;
}

@media (max-width: 880px) {
  .console-card {
    grid-template-columns: 1fr;
  }

  .console-copy {
    min-height: auto;
  }
}
</style>
